import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-device-schedules-card',
  templateUrl: './device-schedules-card.component.html',
  styleUrls: ['./device-schedules-card.component.scss']
})
export class DeviceSchedulesCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  public newSchedules() {
    
  }
}
